import { render, staticRenderFns } from "./HotText.vue?vue&type=template&id=004543d1&scoped=true&"
import script from "./HotText.vue?vue&type=script&lang=js&"
export * from "./HotText.vue?vue&type=script&lang=js&"
import style0 from "./HotText.vue?vue&type=style&index=0&id=004543d1&prod&lang=scss&scoped=true&"
import style1 from "./HotText.vue?vue&type=style&index=1&id=004543d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004543d1",
  null
  
)

export default component.exports